export default [
  {
    path: '/admin/settings/general',
    name: 'settings-general',
    component: () => import('@/views/admin/settings/BusinessSettingView.vue'),
    meta: {
      title: 'General Settings',
      type: 'general',
      pageTitle: 'General Settings',
      breadcrumb: [{ text: 'Settings' }, { text: 'General', active: true }],
    },
  },
  {
    path: '/admin/settings/social',
    name: 'settings-social',
    component: () => import('@/views/admin/settings/BusinessSettingView.vue'),
    meta: {
      title: 'Social Links',
      type: 'social',
      pageTitle: 'Social Links',
      breadcrumb: [{ text: 'Settings' }, { text: 'Social', active: true }],
    },
  },

  {
  path: '/admin/settings/theme',
  name: 'settings-theme',
  component: () => import('@/views/admin/settings/BusinessSettingView.vue'),
  meta: {
    title: 'Theme Settings',
    type: 'theme',
    pageTitle: 'Theme Settings',
    breadcrumb: [{ text: 'Settings' }, { text: 'Theme', active: true }],
  },
},

  // ?? ADD THIS PART
  {
    path: '/admin/settings/pages/:slug',
    name: 'admin-settings-pages',
    component: () => import('@/views/admin/settings/BusinessSettingView.vue'),
    meta: {
      title: 'CMS Pages',
      type: 'pages',
      pageTitle: 'CMS Pages',
      breadcrumb: [{ text: 'Settings' }, { text: 'CMS Pages', active: true }],
    },
  },
]